import React from 'react';
import Typography from '@mui/material/Typography';
import { GridColDef, GridOverlay, GridValueFormatterParams } from '@mui/x-data-grid';
import { formatWashboardTimestamp } from 'utils/formatTimestamp';
import { EntitlementAuditTrailRow } from 'types/entitlements/entitlements';

/** The store picker's value for "every store of the business". */
export const ALL_STORES = 'all';

export const AUDIT_TRAIL_COLUMNS: GridColDef<EntitlementAuditTrailRow>[] = [
  {
    headerName: 'Date & Time',
    field: 'createdAt',
    flex: 1,
    sortable: false,
    valueFormatter: ({ value }: GridValueFormatterParams<string>) =>
      formatWashboardTimestamp(value),
  },
  { headerName: 'Store', field: 'storeName', flex: 1, sortable: false },
  { headerName: 'Entitlement', field: 'entitlement', flex: 0.7, sortable: false },
  { headerName: 'Action', field: 'action', flex: 0.6, sortable: false },
  { headerName: 'Origin', field: 'origin', flex: 0.8, sortable: false },
  { headerName: 'By', field: 'actor', flex: 0.8, sortable: false },
  { headerName: 'Reason', field: 'reason', flex: 2, sortable: false },
];

const NoHistoryOverlay = () => (
  <GridOverlay>
    <Typography variant="body2" color="textSecondary">
      No entitlement changes recorded
    </Typography>
  </GridOverlay>
);

export const AUDIT_TRAIL_GRID_COMPONENTS = { NoRowsOverlay: NoHistoryOverlay };

// There is no total to show, so the footer names the range only, never "of N".
export const AUDIT_TRAIL_GRID_COMPONENTS_PROPS = {
  pagination: {
    labelDisplayedRows: ({ from, to }: { from: number; to: number }) => `${from}–${to}`,
  },
};
